import Typed from "../components/Typed"
import PixelIcon from "../components/PixelIcon"

// Quick links, shown as pixel marks instead of text. `color` is the mark's own
// brand color and feeds the hover glow through a CSS variable, so each one
// blooms in its own color rather than a generic white.
const LINKS = [
    {
        name: "linkedin",
        label: "LinkedIn",
        href: "https://www.linkedin.com/in/amar-dhillon-917537261/",
        color: "#0a66c2",
    },
    {
        name: "github",
        label: "GitHub",
        href: "https://github.com/AmarDhillon05",
        color: "#f0f6fc",
    },
    {
        name: "kaggle",
        label: "Kaggle",
        href: "https://www.kaggle.com/amardhillon05",
        color: "#20beff",
    },
]

export default function Home(){
    return (
        <div className = "flex items-center justify-center flex-col min-h-screen w-full">
            <h1 className = "header text-6xl text-center px-4">Hi, I'm Amar</h1>

            <Typed text = {`, student, builder, researcher, and more.


                            `}
                    classList = "text-4xl py-3 w-auto text-center m-auto"
                    delay = {500}
                ></Typed>

            <div className="social-block">
                <p className="social-heading">quick links</p>

                <div className="social-row">
                    {LINKS.map((link, i) => (
                        <a
                            key={link.name}
                            href={link.href}
                            target="_blank"
                            rel="noreferrer"
                            className="social-link"
                            aria-label={link.label}
                            style={{ "--accent": link.color, animationDelay: `${i * 0.9}s` }}
                        >
                            {/* the staggered delay above keeps the three from
                                drifting in lockstep */}
                            <PixelIcon name={link.name} depth={2} className="social-icon" />
                            <span className="social-label">{link.label}</span>
                        </a>
                    ))}
                </div>
            </div>

            <a className = "home-more text-3xl italic pt-3" href = "#about">Learn more about me</a>

        </div>
    )
}
